import { createFileRoute } from '@tanstack/react-router';
import { SignInPage } from '../components/SignInPage';

export const Route = createFileRoute('/')({
  component: Index,
});

function Index() {
  return <SignInPage />;
}